import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {LogementService} from './logement.service';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SonergiaService {
  constructor(
    private logementService: LogementService,
  ) {
  }

  public sonergiaPartner() {
    return this.logementService.logementCourant.pipe(map(logement => {
      return logement?.societe?.partner?.id === environment.SonergiaPartnerId;
    }));
  }
}
